import { render, staticRenderFns } from "./HoverDot.vue?vue&type=template&id=cf036f36"
import script from "./HoverDot.vue?vue&type=script&lang=js"
export * from "./HoverDot.vue?vue&type=script&lang=js"
import style0 from "./HoverDot.vue?vue&type=style&index=0&id=cf036f36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports